import React, {useState} from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Snack from "@material-ui/core/SnackbarContent";
import IconButton from "@material-ui/core/IconButton";
import Button from "components/CustomButtons/Button.js";

// @material-ui/icons
import Close from "@material-ui/icons/Close";

import styles from "assets/jss/material-dashboard-pro-react/components/snackbarContentStyle.js";
import btnStyles from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.js";


const useStyles = makeStyles(styles);
const useBtnStyles = makeStyles(btnStyles);

export default function SnackbarContent(props) {
  const msgDeterminación = {
    hipertension: "La hipertensión puede causar la obstrucción o la rotura de las arterias que llevan la sangre y el oxígeno al cerebro, lo que provocaría un accidente cerebrovascular. Asimismo, puede causar daños renales que generen una insuficiencia renal",
    diabetes: "El exeso de azúcar en la sangre puede causar problemas en tu cuerpo. Puede dañar tus ojos, riñones, nervios, piel, corazón y vasos sanguíneos",
    dislipidemia: "El exeso de trigliceridos y colesterol puede causar Hinchazon de las extremidades, mal aliento, indigestion, dificultades en el ritmo intestinal, dolor de pecho, jaqueca y vision borrosa",
    imc: "El exceso de peso Es un problema médico que aumenta el riesgo de enfermedades y problemas de salud, como enfermedades cardíacas, diabetes, presión arterial alta y determinados tipos de cáncer"
  }  
  const [active, setActive] = useState(false);
  const classes = useStyles();
  const btnClasses = useBtnStyles()
  const { message, color, close, icon, titleSnack, spanSnack, div, title, link, detInfo, classWarnig } = props;
  var action = [];
  const messageClasses = cx({
    [classes.iconMessage]: icon !== undefined,
  });
  if (close !== undefined) {
    action = [
      <IconButton
        className={classes.iconButton}
        key="close"
        aria-label="Close"
        color="inherit"
      >
        <Close className={classes.close} />
      </IconButton>,
    ];
  }
  const iconClasses = cx({
    [classes.icon]: classes.icon,
    [classes.infoIcon]: color === "info",
    [classes.successIcon]: color === "success",
    [classes.warningIcon]: color === "warning",
    [classes.dangerIcon]: color === "danger",
    [classes.primaryIcon]: color === "primary",
    [classes.roseIcon]: color === "rose",
  });
  const seMore = e => {
    e.preventDefault();
    if (active === false) {
        setActive(true)
    } else {
        setActive(false)
    }
  }
  return (
    <Snack
      className={classWarnig}
      message={
        <div className="content-info-det">
          {div ? (
            <div className="sub-content-icon">
              {icon !== undefined ? <props.icon className="" /> : null}
            </div>
          ) : (
            <>
              {icon !== undefined ? <props.icon className={iconClasses} /> : null}
            </>
          )}
          {titleSnack ? <h4 className="titleSnack">{titleSnack}</h4> : null}
          <span className={`${messageClasses} ${spanSnack !== '' ? spanSnack : ''} span-info-det`}>{title} 
          {link ? (
            <Button 
                color="" 
                simple 
                className="btn-more"
                onClick={seMore}
            >
                Ver más...
            </Button>
          ) : null}
          </span>

          {active ? (
              detInfo ? (
                <div className="more-info">                
                  <p>{msgDeterminación[detInfo]}</p>
                </div>  
              ) : null
          ) : null}
        </div>
      }
      classes={{
        root: classes.root + " " + classes[color],
        message: classes.message,
      }}
      action={action}
    />
  );
}

SnackbarContent.defaultProps = {
  color: "info",
};

SnackbarContent.propTypes = {
  message: PropTypes.node.isRequired,
  titleSnack: PropTypes.string,
  color: PropTypes.oneOf([
    "info",
    "success",
    "warning",
    "danger",
    "primary",
    "rose",
    "white",
    "behance"
  ]),
  close: PropTypes.bool,
  icon: PropTypes.object,
};
